import React, { Component, createRef } from "react";
import ValidationText from "../../utils/validation/ValidationText.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import Selector from "../../components/dropdown/commonDropdown/Selector.js";
import moment from "moment";
import * as XLSX from "xlsx";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { height } from "@fortawesome/free-solid-svg-icons/fa0";
import { FinancealYearStartDateEndDate } from "../../utils/FinancialYearStartDateEndDate.js";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class JobChargesReport extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.productionServices = new ProductionServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      batchClearedList: [],
      categoryTotals: [],
      totalCount: 0,
      totalAmount: 0,
      filterDetails: {
        startDate: "",
        endDate: "",
        sortBy: "Detail",
        itemCategory: "",
        itemId: "",
      },
      tableStatus: "",
      itemCategoryList: [],
      companyItemList: [],
      typeList: [{ material: "Detail" }, { material: "Summary" }],
      validState: {
        isValid: true,
        error: {},
      },
      validationRules: {
        startDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "start date"
            ),
          },
        ],
        endDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "end date"
            ),
          },
        ],
      },
    };
  }

  componentDidMount() {
    let dates = FinancealYearStartDateEndDate()
    let filterDetails = this.state.filterDetails
    filterDetails.startDate = dates.startDate
    filterDetails.endDate = dates.endDate
    this.setState({ filterDetails: filterDetails })
    this.getAllItemCategory();
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }

  getAllJobChargeRecords = () => {
    let isAllFieldsValidate = this.isAllFieldsValidate();
    if (isAllFieldsValidate) {
      this.setState({ tableStatus: "Loading..." }, () => {
        let request = this.state.filterDetails;
        this.productionServices
          .getAllJobChargeRecords(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
              if (response.responseData.length === 0) {
                this.setState({ tableStatus: "No Record Found" })
              } else {
                this.setState({ tableStatus: "" })
              }
              let res = response.responseData;
              res = res.filter((x) => x.productDetialsId !== null);

              let totalCount = res.length;
              res.forEach((item) => {
                item.amount = item.quantity * item.packingItemId.JobCharge;
              });

              const totalAmount = res.reduce((sum, item) => sum + item.amount, 0);

              this.setState({
                batchClearedList: res,
                totalCount: totalCount,
                totalAmount: totalAmount.toFixed(2),
              });
            } else {
              this.setState({ tableStatus: "" })
              this.SwalServices.Error(
                response.Message
              );
            }
          });
      })
    }
  };

  getAllItemCategory = () => {
    this.commonServices.getAllItemCategory().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.setState({ itemCategoryList: response.responseData }, () => {
          this.getAllItem();
        });
      } else {
        this.SwalServices.Error(
          response.Message
        );
        this.getAllItem();
      }
    });
  };
  getAllItem = () => {
    this.commonServices.getAllItem().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.ItemName,
          value: item._id,
          packing: item.Packing,
        }));

        this.setState({ companyItemList: dropdownItems });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  isAllFieldsValidate = () => {
    const newValidState = isValidForm(
      this.state.filterDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.filterDetails;
    details[name] = value;
    this.setState({ filterDetails: details });
  };
  handleDropdownChange = (e, name) => {
    const value = e.target.value;
    let details = this.state.filterDetails;
    details[name] = value;
    this.setState({ filterDetails: details });
  };
  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.filterDetails;
    details[drpIdentity] = selected.value;
    this.setState({ filterDetails: details });
  };


  render() {
    return (
      <div className="jobChargesReport-page">
        <div className="item-search !mb-2.5">
          <div className="item-grp flex gap-2.5">
            <div className="input-grp w-[20%]">
              <label>Start Date</label>
              <input
                type="date"
                id="startDate"
                className={`inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                name="startDate"
                autoComplete="off"
                value={this.state.filterDetails.startDate}
                onChange={(event) => this.handleChange(event, "startDate")}
              />
              {/* <ValidationText error={this.state.validState.error.startDate} /> */}
            </div>
            <div className="input-grp w-[20%]">
              <label>End Date</label>
              <input
                className={`inputFocus ${this.state.validState?.error?.endDate ? "errorInput" : ""}`}
                type="date"
                id="endDate"
                name="endDate"
                autoComplete="off"
                value={this.state.filterDetails.endDate}
                onChange={(event) => this.handleChange(event, "endDate")}
              />
              {/* <ValidationText error={this.state.validState.error.endDate} /> */}
            </div>
            <div className="input-grp w-[20%]">
              <label>Category</label>
              <select
                name="itemCategory"
                value={this.state.filterDetails.itemCategory}
                onChange={(e) => this.handleDropdownChange(e, "itemCategory")}
              >
                <option>Select</option>
                {this.state.itemCategoryList.map((x, key) => (
                  <option key={key} value={x.categoryName}>
                    {x.categoryName}
                  </option>
                ))}
              </select>
            </div>
            <div className="input-grp w-[40%]">
              <label>Product</label>
              <MultiSelectDropdown
                drpIdentity="itemId"
                options={this.state.companyItemList}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selected) =>
                  this.setFilterParameters(selected, "itemId", "filterDetails")
                }
                allowSelectAll={false}
                value={this.state.companyItemList.filter(
                  (party) => party.value === this.state.filterDetails.itemId
                )}
              />
            </div>
          </div>
          <div className="item-grp flex gap-2.5 mt-3">
            <div className="btn-grp">
              <button
                class="search-btn"
                onClick={() => this.getAllJobChargeRecords()}
              >
                Search
              </button>
              {this.state.totalCount > 0 ? (
                <button
                  class="print-btn"
                  onClick={() => printFunction()}
                >
                  Print
                </button>
              ) : null}
            </div>
          </div>
        </div>
        <div className="total-count flex gap-2.5 mb-[3px] justify-between">
          <p className="text-[15px] font-medium text-[#474747]">Total Count :- {this.state.totalCount}</p>
          <p className="text-[15px] font-medium text-[#474747] mr-[3px]">Total Amount :- {this.state.totalAmount}</p>
        </div>
        <div class="item-listing">
          <div className="hidden print-title">
            <h4>Job Charge Report</h4>
            {/* {this.state.filterDetails.categoryName !== "" ? <p className="text-black">Category type:- {this.state.filterDetails.categoryName}</p> : null} */}
          </div>
          <div class="itemList-table">
            <div class="table-container" style={{ height: "calc(100vh - 200px)" }}>
              {this.state.filterDetails.sortBy === "Detail" ? (
                <table class="itemList">
                  <thead>
                    <tr>
                      <td className="w-[3%] no-print">Sr.</td>
                      <td className="w-[10%]">Prod.No</td>
                      <td className="w-[10%]">Desp.Date</td>
                      <td className="w-[25%]">Product Name</td>
                      <td className="w-[10%]">Batch No</td>
                      <td className="w-[10%]">Packing</td>
                      <td className="w-[10%]">Qty.</td>
                      <td className="w-[10%]">Job Charges</td>
                      <td className="w-[12%]">Amount</td>
                    </tr>
                  </thead>
                  {this.state.batchClearedList &&
                    this.state.batchClearedList.length > 0 ? (
                    this.state.batchClearedList.map((item, key) => (
                      <tbody key={key}>
                        <tr>
                          <td className="no-print">{key + 1}</td>
                          <td>{item.productDetialsId.productionNo}</td>
                          <td>
                            {item.productDetialsId.despDate
                              ? moment(item.productDetialsId.despDate).format(
                                "DD MMM yyyy"
                              )
                              : ""}
                          </td>
                          <td>
                            {item.packingItemId?.ItemName
                              ? item.packingItemId?.ItemName
                              : ""}
                          </td>
                          <td className="print:break-all">{item.productDetialsId.batchNo}</td>
                          <td>{item.packing}</td>
                          <td>{item.quantity.toFixed(2)}</td>
                          <td>{item.packingItemId.JobCharge.toFixed(2)}</td>
                          <td>
                            {(
                              item.quantity * item.packingItemId.JobCharge
                            ).toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    ))
                  ) : this.state.batchClearedList &&
                    this.state.batchClearedList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={9} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.batchClearedList &&
                    this.state.batchClearedList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
                </table>
              ) : (
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: "7%" }}>Category</td>
                      <td style={{ width: "10%" }}>Batch Size</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.categoryTotals &&
                      this.state.categoryTotals.length > 0
                      ? this.state.categoryTotals.map((item, key) => (
                        <tr key={key}>
                          <td>{item.category}</td>
                          <td>{item.totalBatchSize}</td>
                        </tr>
                      ))
                      : this.state.categoryTotals &&
                        this.state.categoryTotals.length === 0
                        && this.state.tableStatus !== "" ? (
                        <tr>
                          <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                            {this.state.tableStatus}
                          </td>
                        </tr>
                      ) : this.state.categoryTotals &&
                        this.state.categoryTotals.length === 0
                        && this.state.tableStatus === "" ? null : ""}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">Job Charges Report</div>
                  </td>
                  <td>
                    <div className="hdr-meta">
                      Start Date: <strong>{this.state.filterDetails.startDate}</strong><br />
                      End Date: <strong>{this.state.filterDetails.endDate}</strong>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
                                                      <div>
                                                        <span className="info-label">Item Name:</span>
                                                        <p className="info-value">Paracetamol</p>
                                                      </div>
                                                    </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "30%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "10%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Prod No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Desp Date
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Product Name
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Batch No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Packing
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Quantity
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Job Charge
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.batchClearedList &&
                  this.state.batchClearedList.length > 0 ?
                  this.state.batchClearedList.map((item, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {item.productDetialsId.productionNo}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item.productDetialsId.despDate
                          ? moment(item.productDetialsId.despDate).format(
                            "DD MMM yyyy"
                          )
                          : ""}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item.packingItemId?.ItemName
                          ? item.packingItemId?.ItemName
                          : ""}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item.productDetialsId.batchNo}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item.packing}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item.quantity.toFixed(2)}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {item.packingItemId.JobCharge.toFixed(2)}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {(
                          item.quantity * item.packingItemId.JobCharge
                        ).toFixed(2)}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="8" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default JobChargesReport;
